import { useState } from 'react';
import { useTheme } from '@mui/material';

import { ActionsAccordion } from './components/ActionsAccordion';
import { CandidateRowActionsProps } from '../../types';
import { ConnectActionsContainer } from '../../styles/actionsStyles';
import { RequiredActionsCTA } from './components/RequiredActionsCTAs';
import auth from 'utils/auth';

export const CandidateRowActions: React.FC<CandidateRowActionsProps> = ({
  actions,
  applicationId,
  candidateId,
  hasCompletedAllRequiredActions,
  onOpenModal,
  requirements,
  roleId,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const theme = useTheme();

  const handleExpansion = () => setIsExpanded(!isExpanded);

  const getRequiredActions = () => {
    if (!auth.isSuperAdminUser()) {
      return { scorecard: actions.scorecard, reference: actions.reference };
    }
    return actions;
  };

  const requiredActions = getRequiredActions();
  const hasCompletedAllActions = Object.values(requiredActions).every((completed) => completed);

  const getBackgroundColor = () => {
    if (hasCompletedAllRequiredActions) {
      return theme.palette.primary.fill;
    }

    return theme.palette.gray.lightest;
  };

  const applicationLink = applicationId
    ? `/district/profile/${candidateId}/?application=${applicationId}`
    : null;

  return (
    <ConnectActionsContainer
      sx={{
        backgroundColor: getBackgroundColor(),
      }}
    >
      <ActionsAccordion
        applicationLink={applicationLink}
        actions={actions}
        candidateId={candidateId}
        handleExpansion={handleExpansion}
        isExpanded={isExpanded}
        onOpenModal={onOpenModal}
        requirements={requirements}
        roleId={roleId}
        hasCompletedAllActions={hasCompletedAllActions}
        requiredActions={requiredActions}
        hasCompletedAllRequiredActions={hasCompletedAllRequiredActions}
      />
      <RequiredActionsCTA
        applicationLink={applicationLink}
        actions={actions}
        candidateId={candidateId}
        isExpanded={isExpanded}
        onOpenModal={onOpenModal}
        requirements={requirements}
        roleId={roleId}
      />
    </ConnectActionsContainer>
  );
};
